var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000003783597155787724880000003860338752325051807_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.7 264",
    style: {
      enableBackground: "new 0 0 353.7 264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.9,236.1h-42.1V65h42.1V236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,236.1h18.5c0-6.5,0.1-12.9,0-19.2c-0.2-8-0.5-15.9-0.7-23.8c-0.1-2.1,0.4-3.4,2.8-3.3 c8.7,0.3,17.4,0.4,26.1,0.8c4.3,0.2,9.1-3.6,9.2-8c0.1-3.3-3.5-6.3-7.8-6.3c-7.2,0-14.5-0.1-21.7,0c-2.4,0-4.9,0.5-8,0.9v-76.7 c1.1,0,2.7,0,4.2,0c8.1,0,16.2,0,24.4,0c4.9,0,8.3-3.1,8.2-7.4c-0.1-4.4-3.1-6.9-8.3-6.9c-7,0-14-0.1-21,0c-2.3,0-4.6,0.5-7.2,0.7 V13.5c2.9,0,5.9,0,8.8,0c7.2,0,14.5,0,21.7,0c3.4,0,6.4-3.1,6.6-6.6C56,3.9,52.2,0,49.2,0c-6.5,0-13,0-19.5,0H0V236.1L0,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,236.1H85.6c-0.3-5.8-0.6-11.4-0.8-17c-0.1-1.1-0.1-2.2-0.1-3.4c0-35.6,0-71.2,0-106.8 c0-4.6,2.3-6.9,6.8-6.9c5.6,0,11.2-0.1,16.9,0c6.4,0.2,12.9,0.6,19.6,0.9C127.9,102.9,127.9,236.1,127.9,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.4,114.5h42.3V236h-42.3V114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,263.3c-54.5,0-109,0-163.5,0c-3.6,0-7.1,0.6-10.7,0.7c-3.9,0.1-6.6-2.5-7.1-6.5c-0.4-2.9,2.2-8,4.9-8.1 c4.4-0.2,8.9,0.3,13.3,0.6c1.7,0.1,3.4,0.6,5.1,0.6c107.5,0,214.9,0,322.4,0c6.4,0,8.9,4.1,6.3,9.9c-1.1,2.6-3,2.8-5.4,2.8 c-34.1-0.1-68.2,0-102.3,0H182L182,263.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.2,153.9H335v82h-34.8V153.9L300.2,153.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.8e0a702d2a160d35a49b27a0c21b06f2.svg";
export { ForwardRef as ReactComponent };